import { render, staticRenderFns } from "./SelectPhoto.vue?vue&type=template&id=67cadabd&scoped=true&"
import script from "./SelectPhoto.vue?vue&type=script&lang=js&"
export * from "./SelectPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SelectPhoto.vue?vue&type=style&index=0&id=67cadabd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cadabd",
  null
  
)

export default component.exports